import { emit } from "../core/events";

export function setupClipboardWatcher() {
  let selText = "";
  document.addEventListener("selectionchange", () => {
    selText = window.getSelection()?.toString() || selText;
  });
  document.addEventListener("copy", () => {
    const expected = selText;
    setTimeout(async () => {
      try {
        const clip = await navigator.clipboard.readText();
        if (expected && clip && clip !== expected) {
          emit({ type: "clipboard.tamper", data: { expected, got: clip } });
        }
      } catch {
        emit({ type: "clipboard.permission", data: {} });
      }
    }, 100);
  });
}
